import { environment } from './environments/environment'

// Ships in the polyfills bundle, so it runs while the app bundle is still
// downloading and the API and socket handshakes overlap with that download.
const preconnect = (url: string, crossOrigin: boolean): void => {
  try {
    const link = document.createElement('link')
    link.rel = 'preconnect'
    link.href = new URL(url).origin
    if (crossOrigin) link.crossOrigin = 'anonymous'
    document.head.appendChild(link)
  } catch {
    // A malformed URL must never stop the app from booting.
  }
}

preconnect(environment.apiUrl, true)
preconnect(environment.websocketUrl, false)
